export default {
  current: 'Aktuell',
  noActiveRecipe: 'Kein aktives Rezept an diesem Ofen.',
};
